'use client';

import { useState } from 'react';

import {
    Box,
    BoxContent,
    Button,
    ButtonList,
    ButtonVariant,
    ModalBody,
    ModalFooter,
    RadioTile,
    RadioTiles,
    Spacer,
    SpacerSize,
    Sticker,
    Text,
    TextLevels,
    TrilogyColor,
    TypographyAlign,
    TypographyBold,
    VariantState,
} from '@bytel/trilogy-react';

import { PLAY } from '@constants/provider';

import { FaiUpsellModalProps } from './fai-upsell-modal.props';

export function DowngradePlayUpsellModal({ clickedOffer, upsellOffer, onAddOffer }: Readonly<FaiUpsellModalProps>) {
    const [choice, setChoice] = useState<PLAY>(PLAY._3P);
    const isUltymOffer = clickedOffer.rangeNg === 'ultym';

    return (
        <>
            <ModalBody>
                <Text typo={TypographyAlign.TEXT_LEFT}>
                    Profitez de + de 180 chaînes avec votre {clickedOffer.name}&nbsp;🍿
                </Text>
                <Spacer size={SpacerSize.SIX} />
                <RadioTiles>
                    <RadioTile
                        name='checkbox1'
                        id='choiceYes'
                        label='Avec un décodeur TV'
                        description='Sur votre TV principale.'
                        value={PLAY._3P}
                        checked={choice === PLAY._3P}
                        onChange={() => setChoice(PLAY._3P)}
                        horizontal
                    />
                    <RadioTile
                        name='checkbox1'
                        id='choiceNo'
                        label='Avec l’application b.tv'
                        description='Sur votre TV connectée, smartphone, tablette, PC.'
                        value={PLAY._2P}
                        checked={choice === PLAY._2P}
                        onChange={() => setChoice(PLAY._2P)}
                        horizontal
                    />
                </RadioTiles>
                {isUltymOffer && (
                    <Box shadowless highlighted={TrilogyColor.ACCENT}>
                        <BoxContent backgroundColor={TrilogyColor.ACCENT_FADE}>
                            <Sticker label='Inclus' small variant={VariantState.ACCENT} />
                            <Text
                                level={TextLevels.TWO}
                                typo={[TypographyAlign.TEXT_LEFT, TypographyBold.TEXT_WEIGHT_BOLD]}
                            >
                                {choice === PLAY._3P
                                    ? 'L’application b.tv sur 5 écrans en simultané avec un 2nd décodeur\u00A0!'
                                    : 'L’application b.tv sur 5 écrans en simultané\u00A0!'}
                            </Text>
                            <Text level={TextLevels.TWO}>
                                {choice === PLAY._3P
                                    ? 'Activez l’option b.tv multi-écrans avec un 2nd décodeur dans votre espace client.'
                                    : 'Activez l’option b.tv multi-écrans dans votre espace client.'}
                            </Text>
                        </BoxContent>
                    </Box>
                )}
            </ModalBody>
            <ModalFooter>
                <ButtonList>
                    <Button
                        variant={ButtonVariant.CONVERSION}
                        onClick={() => onAddOffer?.(choice === PLAY._3P ? clickedOffer : upsellOffer)}
                    >
                        Continuer
                    </Button>
                </ButtonList>
            </ModalFooter>
        </>
    );
}
